import React from 'react';
import logo from "../../images/logo.webp";
import "./LoadingSpinner.css"

function LoadingSpinner({ isLoading }) {
  if (isLoading) {
    return (
      <div className="loading-screen">
        <img src={logo} alt="Logo" className="w-50 h-50 text-primary spinner" />
      </div>
    );
  } else {
    return null;  // Don't render anything if not loading
  }
}

export default LoadingSpinner;
